let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gbJJs")).then(() => parcelRequire('gjJ2S'));